import React from 'react';
import { ADVENTURE_GREEN, ELEMENT_GRAY, RIOJA_RED } from '../colors';
import ChevronBackIcon from '@tourlane/iconography/Glyphs/Navigation/ChevronBack';
import ChevronForwardIcon from '@tourlane/iconography/Glyphs/Navigation/ChevronForward';
import ChevronUpIcon from '@tourlane/iconography/Glyphs/Navigation/ChevronUp';
import ChevronDownIcon from '@tourlane/iconography/Glyphs/Navigation/ChevronDown';
import CloseIcon from '@tourlane/iconography/Glyphs/Navigation/Close';
export var getInputButtonColor = function getInputButtonColor(focused, disabled, error, persistError) {
  if (persistError === void 0) {
    persistError = false;
  }

  return (
    /* prettier-ignore */
    disabled ? ELEMENT_GRAY : persistError && error ? RIOJA_RED : focused ? ADVENTURE_GREEN : error ? RIOJA_RED : ELEMENT_GRAY
  );
};
export var getIconColor = function getIconColor(disabled) {
  return disabled ? ELEMENT_GRAY : ELEMENT_GRAY;
};
export var getIconHoverColor = function getIconHoverColor(disabled) {
  return disabled ? ELEMENT_GRAY : ADVENTURE_GREEN;
};

var _ref = /*#__PURE__*/React.createElement(ChevronBackIcon, null);

var _ref2 = /*#__PURE__*/React.createElement(ChevronForwardIcon, null);

var _ref3 = /*#__PURE__*/React.createElement(ChevronUpIcon, null);

var _ref4 = /*#__PURE__*/React.createElement(ChevronDownIcon, null);

var _ref5 = /*#__PURE__*/React.createElement(CloseIcon, null);

export var getIcon = function getIcon(hasArrow, hasClose, arrow) {
  if (arrow === void 0) {
    arrow = 'right';
  }

  if (hasArrow) {
    switch (arrow) {
      case 'left':
        return _ref;

      case 'right':
        return _ref2;

      case 'top':
        return _ref3;

      case 'bottom':
        return _ref4;
    }
  }

  if (hasClose) {
    return _ref5;
  }

  return null;
};